import { ConfigProvider, Empty } from "antd";
import en from "antd/lib/locale/en_US";
import vi from "antd/lib/locale/vi_VN";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "store";
import App from "./App";
import "./i18n";

const language = localStorage.getItem("i18nextLng") ?? "vi";

const locale = language === "en" ? en : vi;

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	<React.StrictMode>
		<ConfigProvider renderEmpty={() => <Empty style={{ background: "unset" }} />} locale={locale}>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<App />
				</PersistGate>
			</Provider>
		</ConfigProvider>
	</React.StrictMode>
);
